import React from "react";
import { Row, Col } from "antd";



export default function ApplicationNotesCard() {
  return (

    <Row justify="center" className="margin5px">
      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
        <div className="page-wrapper">
          <div className="notes-card">
            <div className="notes-header">
              <h2>Application Notes</h2>
            </div>


            <div className="notes-body">
              <div className="notes-row">
                <div className="notes-text">
                  <p className="title">Application created</p>
                  <p className="description">
                    Initial application draft created. Awaiting completion of all required fields and document uploads.
                  </p>
                </div>
                <span className="date">7th Jan 2026</span>
              </div>


              <div className="notes-empty">
                No additional notes yet
              </div>
            </div>
          </div>
        </div>
      </Col>
    </Row>

  );
}